import { FC, PropsWithChildren, ReactNode } from 'react';
import { noop } from 'lodash';
import classNames from 'classnames';
import { useContextSelector } from 'use-context-selector';
import { IonItem, IonLabel } from '@ionic/react';
import { useTheme } from 'styled-components';

import { ActionSheetMenuContext } from '../ActionSheetMenu.context';

import styles from './ActionSheetMenuCta.module.scss';

type ActionSheetMenuCtaProps = PropsWithChildren<{
  icon?: ReactNode;
  onClick?: () => void;
}>;

export const ActionSheetMenuCta: FC<ActionSheetMenuCtaProps> = ({
  icon,
  children,
  onClick = noop,
}) => {
  const { fontSize } = useTheme();

  const dismiss = useContextSelector(
    ActionSheetMenuContext,
    ({ dismiss }) => dismiss
  );

  const handleOnClick = () => {
    onClick();
    dismiss();
  };

  return (
    <IonItem
      button
      lines="full"
      className={classNames(styles.root, {
        [styles.withIcon]: !!icon,
      })}
      onClick={handleOnClick}
    >
      {!!icon && (
        <div slot="start" className={styles.icon}>
          {icon}
        </div>
      )}
      <IonLabel style={{ fontSize: fontSize(16) }} className={styles.label}>
        {children}
      </IonLabel>
    </IonItem>
  );
};
